export enum FALL_PROTECTION_CATEGORY {
  FALLS = 'falls',
  CUTS = 'cuts',
}
